import { bindProductWidgets } from '../ProductWidget/ProductWidget';

export const recommendedProductsInit = () => {
  const productRecommendationsSection = document.querySelector(
    '.product-recommendations'
  ) as HTMLElement;

  if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          bindProductWidgets();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
};
